import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OccTrackingPickupService, TrackingActions } from '@tracking/data-access';
import { Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, pairwise, switchMap } from 'rxjs/operators';

@Injectable()
export class TrackingPickupEffect {
  load$: Observable<TrackingActions.TrackingPickupLoadSuccess | TrackingActions.TrackingPickupLoadFail> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TrackingActions.LOAD_TRACKING_PICKUP),
        map((action: TrackingActions.TrackingPickupLoad) => action.orderGuid),
        switchMap((trackingId) => {
          return this.occTrackingPickupService.load(trackingId).pipe(
            map((response) => new TrackingActions.TrackingPickupLoadSuccess(trackingId, response)),
            catchError((error) => of(new TrackingActions.TrackingPickupLoadFail(trackingId, error))),
          );
        }),
      ),
  );

  resetPrevious$: Observable<TrackingActions.TrackingPickupReset> = createEffect(() =>
    this.actions$.pipe(
      ofType(TrackingActions.LOAD_TRACKING_PICKUP),
      map((action: TrackingActions.TrackingPickupLoad) => action.orderGuid),
      distinctUntilChanged(),
      pairwise(),
      map(([prevTrackingId]) => new TrackingActions.TrackingPickupReset(prevTrackingId)),
    ),
  );

  constructor(
    private actions$: Actions,
    private occTrackingPickupService: OccTrackingPickupService,
  ) {}
}
